import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifySearch01 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.5608 28.439L25.3278 23.206C26.6404 21.3613 27.2119 19.0907 26.9292 16.8444C26.6464 14.5981 25.5299 12.54 23.801 11.0782C22.0722 9.61632 19.8572 8.85742 17.5951 8.9519C15.333 9.04639 13.189 9.98735 11.5881 11.5883C9.98717 13.1892 9.0462 15.3332 8.95172 17.5953C8.85724 19.8574 9.61613 22.0724 11.078 23.8012C12.5398 25.5301 14.5979 26.6465 16.8442 26.9293C19.0905 27.2121 21.3611 26.6406 23.2058 25.328L28.4388 30.561C28.7202 30.8424 29.1019 31.0005 29.4998 31.0005C29.8978 31.0005 30.2794 30.8424 30.5608 30.561C30.8422 30.2796 31.0003 29.898 31.0003 29.5C31.0003 29.1021 30.8422 28.7204 30.5608 28.439ZM10.9998 18C10.9998 16.6155 11.4104 15.2622 12.1795 14.111C12.9487 12.9599 14.042 12.0627 15.321 11.5329C16.6001 11.003 18.0076 10.8644 19.3655 11.1345C20.7233 11.4046 21.9706 12.0713 22.9496 13.0503C23.9285 14.0292 24.5952 15.2765 24.8653 16.6344C25.1354 17.9922 24.9968 19.3997 24.467 20.6788C23.9372 21.9579 23.04 23.0511 21.8888 23.8203C20.7377 24.5895 19.3843 25 17.9998 25C16.144 24.9979 14.3647 24.2597 13.0524 22.9474C11.7401 21.6351 11.0019 19.8559 10.9998 18Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgMagnifySearch01);
export default ForwardRef;
